import React from 'react';
import { Palette, Shield, Zap, CheckCircle } from 'lucide-react';

export const WhyChooseSection = () => {
  return (
    <div className="border-t pt-8">
      <h3 className="text-xl font-bold text-center mb-6">Why Choose ZenStudios?</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="text-center p-4">
          <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
            <Palette className="w-6 h-6 text-primary" />
          </div>
          <h4 className="font-semibold mb-2">Expert Design</h4>
          <p className="text-sm text-gray-600">Our team of experienced designers brings your vision to life with precision and creativity.</p>
        </div>
        <div className="text-center p-4">
          <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
            <Shield className="w-6 h-6 text-primary" />
          </div>
          <h4 className="font-semibold mb-2">Quality Assured</h4>
          <p className="text-sm text-gray-600">Premium materials and ISI-certified hardware from trusted brands like Ebco and Hettich.</p>
        </div>
        <div className="text-center p-4">
          <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
            <Zap className="w-6 h-6 text-primary" />
          </div>
          <h4 className="font-semibold mb-2">Timely Delivery</h4>
          <p className="text-sm text-gray-600">Factory-precision manufacturing ensures on-time delivery without compromising quality.</p>
        </div>
      </div>
    </div>
  );
};

export const HeroSection = () => {
  return (
    <section className="py-12 md:py-20 bg-gradient-to-br from-amber-50 via-white to-primary/5">
      <div className="max-w-7xl mx-auto px-4 text-center">
        <span className="inline-block px-4 py-1 bg-primary/10 text-primary rounded-full text-sm font-medium mb-4">
          Interior Design Services
        </span>
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Transform Your Space with <span className="text-primary">ZenStudios</span>
        </h1>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
          Get an instant, detailed cost estimate for your interior design project. 
          Our proprietary Z-Engine algorithm ensures accurate pricing based on your exact requirements.
        </p>
        <div className="flex flex-wrap justify-center gap-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <CheckCircle className="w-4 h-4 text-primary" />
            <span>Premium Materials</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <CheckCircle className="w-4 h-4 text-primary" />
            <span>ISI Hardware</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <CheckCircle className="w-4 h-4 text-primary" />
            <span>Factory Precision</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <CheckCircle className="w-4 h-4 text-primary" />
            <span>10-Year Warranty</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default { WhyChooseSection, HeroSection };
